module.exports = __webpack_public_path__ + "static/eosgo-banner-1c6d2130eac4d29394f4fc7429acf44b.jpg";